// AUTO-GENERATED SQL Builder (V40 Final) for BookingPackageLine
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class BookingPackageLineSql {
  private ast = new SqlAst('BookingPackageLine', 'bookingPackageLine');
  public readonly main: any = {};

  public guid: SqlField;
  public bookingPackageId: SqlField;
  public description: SqlField;
  public amount: SqlField;
  public isBundleCustomerLine: SqlField;
  public sortOrder: SqlField;
  public isDiscount: SqlField;
  public bookingPackage: SqlNavHybrid;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('bookingPackageLine', 'guid', '', 'id', 'bookingPackageLine_guid');
    this.bookingPackageId = new SqlField('bookingPackageLine', 'bookingPackageId', 'bookingPackage', 'id', 'bookingPackageLine_bookingPackage');
    this.description = new SqlField('bookingPackageLine', 'description', '', 'id', 'bookingPackageLine_description');
    this.amount = new SqlField('bookingPackageLine', 'amount', '', 'id', 'bookingPackageLine_amount');
    this.isBundleCustomerLine = new SqlField('bookingPackageLine', 'isBundleCustomerLine', '', 'id', 'bookingPackageLine_isBundleCustomerLine');
    this.sortOrder = new SqlField('bookingPackageLine', 'sortOrder', '', 'id', 'bookingPackageLine_sortOrder');
    this.isDiscount = new SqlField('bookingPackageLine', 'isDiscount', '', 'id', 'bookingPackageLine_isDiscount');
    this.bookingPackage = createNavHybrid('bookingPackageLine', 'bookingPackageLine_bookingPackage', 'BookingPackage');
    this.createdByUser = createNavHybrid('bookingPackageLine', 'bookingPackageLine_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('bookingPackageLine', 'bookingPackageLine_updatedByUser', 'User');
    this.id = new SqlField('bookingPackageLine', 'id', '', 'id', 'bookingPackageLine_id');
    this.isDeleted = new SqlField('bookingPackageLine', 'isDeleted', '', 'id', 'bookingPackageLine_isDeleted');
    this.createdBy = new SqlField('bookingPackageLine', 'createdBy', '', 'id', 'bookingPackageLine_createdBy');
    this.createdDate = new SqlField('bookingPackageLine', 'createdDate', '', 'id', 'bookingPackageLine_createdDate');
    this.updatedBy = new SqlField('bookingPackageLine', 'updatedBy', '', 'id', 'bookingPackageLine_updatedBy');
    this.updatedDate = new SqlField('bookingPackageLine', 'updatedDate', '', 'id', 'bookingPackageLine_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:BookingPackageLineSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:BookingPackageLineSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:BookingPackageLineSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:BookingPackageLineSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:BookingPackageLineSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:BookingPackageLineSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:BookingPackageLineSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:BookingPackageLineSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:BookingPackageLineSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:BookingPackageLineSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
